import React from 'react';
import { memo } from 'common/hocs/memo';
import { Rating, Typography } from 'fronton-react';
import { styled } from 'linaria/react';

type ProductReviewsProps = {
  rating: number;
  reviewsNumber: number;
  href: string;
  onClick: () => void;
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ProductReviews = memo<ProductReviewsProps>((props: ProductReviewsProps) => {
  const { rating, reviewsNumber, onClick, href } = props;

  return (
    <Container>
      <Rating
        hasLink={true}
        href={href}
        value={rating}
        size={'s'}
        data-qa="product-reviews"
        onClick={onClick}
      />
      <Typography variant="caption" color="text-primary">{`(${reviewsNumber})`}</Typography>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
`;
